module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2022_03.59add6e3.jpg";